<template>
    <div class="h-full">
      <TopBar :show-toggle="true" @go-back="goBack"/>
  
      <div class="flex w-full flex-col flex-grow items-center">
        <img v-if="logo" class="mb-16 h-[73px] w-[172px]" :src="logo" />
        <div v-else class="skeleton mb-16 h-[73px] w-[172px] rounded"></div>
  
        <div class="flex w-full flex-col gap-5">
          <ActionCard
            class="bg-quaternary px-12 py-16 text-dark"
            :icon="IconQrcode"
            text="Ler QR Code da Produto"
            :callback="goToProd"
          />
        </div>
      </div>
    </div>
  </template>
  
  <script setup lang="ts">
  import logo from '@/assets/ssn-logo.png'
  import ActionCard from '@/components/ActionCard/ActionCard.vue'
  import TopBar from '@/components/TopBar/TopBar.vue'
  import { useEventBus } from '@/plugins/eventBus/eventBus'
  import { useAppStore } from '@/stores/app.store'
  import { IconQrcode } from '@tabler/icons-vue'
  import { onMounted, onUnmounted } from 'vue'
  import { useRouter } from 'vue-router'
  
  const eventBus = useEventBus()
  
  const router = useRouter()
  
  const appStore = useAppStore();
  
  async function goBack() {
    appStore.actions.setCurrentPage('MO')
  }
  async function goToProd() {
    router.push({ name: 'read-product' })
  }
  
  onMounted(() => {
    eventBus.on('home:scanProduct', () => {
      goToProd()
    })
  
    appStore.actions.setCurrentReadProduct(null)
    appStore.actions.setCurrentTagReadProduct(null)
  })
  
  onUnmounted(() => {
    eventBus.off('home:scanProduct')
  })
  </script>
  